import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button } from "@cirrus/ui-kit-ts/src/components/atoms/Button"

import { useCustomerInfo } from "../../../CustomerInfo/context"
import { ButtonLoginWithSaml } from "../../components/ButtonLoginWithSaml"
import { AlternativeLoginButtons } from "../../containers/AlternativeLoginButtons"
import { useNavigationService } from "../../providers/NavigationService"

const LOGIN_WITH_USERNAME_BTN_ID = "login-with-username-btn-id"

export const AlternativeLoginForKeycode = () => {
  const { i18n } = useTranslations()
  const { navigate } = useNavigationService()
  const { data } = useCustomerInfo()

  return <AlternativeLoginButtons>
    {data?.saml?.enabled && <ButtonLoginWithSaml/>}

    <Button
      id={LOGIN_WITH_USERNAME_BTN_ID}
      label={`${i18n("Account.Login:LoginWith")} ${i18n("Login:Username")}`}
      variant="outlined" onClick={() => navigate("/login")}/>
  </AlternativeLoginButtons>
}
